import { IBarSegmentConfig } from '../../../components/bar-segment-chart/bar-segment-chart';

const BMI_WIDGET_LABELS: IBarSegmentConfig['labels'] = [
  {
    position: 0,
    valueKey: 'weight',
    descriptionKey: 'life_id.bmi_widget_weight',
    unit: 'kg',
    displayedValue: '-',
    color: 'rgba(41, 49, 87, 0.6)',
    updateColorFromRange: false,
    addRangeToDisplayedValue: false,
    addUnitToDisplayedValue: true,
    hidden: false,
    replaceDescriptionWithRange: false,
  },
  {
    position: 1,
    valueKey: 'bmi',
    descriptionKey: 'life_id.bmi_widget_bmi',
    unit: '',
    displayedValue: '-',
    customCss: 'highlight',
    color: 'rgba(41, 49, 87, 0.6)',
    updateColorFromRange: true,
    addRangeToDisplayedValue: false,
    addUnitToDisplayedValue: false,
    hidden: false,
    replaceDescriptionWithRange: false,
  },
  {
    position: 2,
    valueKey: 'height',
    descriptionKey: 'life_id.bmi_widget_height',
    unit: 'cm',
    displayedValue: '-',
    color: 'rgba(41, 49, 87, 0.6)',
    updateColorFromRange: false,
    addRangeToDisplayedValue: false,
    addUnitToDisplayedValue: true,
    hidden: false,
    replaceDescriptionWithRange: false,
  },
];

const BMI_RANGES = [
  {
    pos: 0,
    name: 'malnutrition',
    from: 0,
    to: 18.5,
    color: '#5F88E8',
  },
  {
    pos: 1,
    name: 'normal',
    from: 18.5,
    to: 24.9,
    color: '#5FE89C',
  },
  {
    pos: 2,
    name: 'overweight',
    from: 25,
    to: 29.9,
    color: '#E5BD6A',
  },
  {
    pos: 3,
    name: 'obeseI',
    from: 30,
    to: 45,
    color: '#FF335C',
  },
];

export const BMI_BAR_CHART_CONFIG: IBarSegmentConfig = {
  labels: BMI_WIDGET_LABELS,
  ranges: BMI_RANGES,
  indicatorKey: 'bmi',
};
